
import { useRef, useState, useEffect } from 'react';
import './SegmentedControlAmPm.css';

const SegmentedControlAmPm = ({
  name,
  segments,
  callback,
  defaultIndex = 0,
  controlRef,
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);

  const onInputChange = (value, index) => {
    setActiveIndex(index);
    callback(value, index);
  }

  return (
    <div className="controls-container" ref={controlRef}>
      <div className="controls">
        {segments.map((item, i) => (
          <div
            key={item.value}
            className={`segment ${i === activeIndex ? 'active' : 'inactive'}`}
            ref={item.ref}
          >
            <input
              type="radio"
              value={item.value}
              id={item.label}
              name={name}
              onChange={() => onInputChange(item.value, i)}
              checked={i === activeIndex}
            />
            <label htmlFor={item.label}>
              {item.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )  
}

export default SegmentedControlAmPm;
 
 
 
 
 
 
